import type { IGetResponse } from '@features/purchasing/my-basket/types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type IProps = Pick<
  IGetResponse,
  'summaryAfterVat' | 'summaryBeforeVat' | 'summaryVat' | 'vatLevels' | 'customerDiscount'
>;

export default function Totals(props: IProps) {
  const { t } = useTranslation();

  const customerDiscount = useMemo(() => props.customerDiscount ?? 0, [props.customerDiscount]);

  return (
    <div className="flex justify-end">
      <div className="max-w-md w-full flex flex-col gap-y-2 p-4 bg-gray-50 rounded-lg font-medium">
        {customerDiscount > 0 && (
          <div className="flex items-baseline justify-between text-red-500">
            <span>{t('CustomerDiscount')}</span>
            <span>{customerDiscount * -1}%</span>
          </div>
        )}

        <div className="flex items-baseline justify-between text-gray-700">
          <span>{t('SummaryPriceBeforeVat')}</span>
          <span>{props.summaryBeforeVat.formatted}</span>
        </div>

        {props.vatLevels.map(vat => (
          <div key={vat.percent} className="flex items-baseline justify-between text-gray-700">
            <span>{vat.label}</span>
            <span>{vat.amount.formatted}</span>
          </div>
        ))}

        <div className="flex items-baseline justify-between text-gray-700">
          <span>{t('SummaryVat')}</span>
          <span>{props.summaryVat.formatted}</span>
        </div>

        <div className="flex items-baseline justify-between text-primary font-bold">
          <span>{t('SummaryPriceAfterVat')}</span>
          <span className="text-lg laptop:text-xl">{props.summaryAfterVat.formatted}</span>
        </div>
      </div>
    </div>
  );
}
